import { DateTime } from "luxon"
import { StrictOmit } from "../../../../lib/lang"
import { History } from "../../../users/userTypes"

export enum WeekDays {
    MONDAY = "MONDAY",
    TUESDAY = "TUESDAY",
    WEDNESDAY = "WEDNESDAY",
    THURSDAY = "THURSDAY",
    FRIDAY = "FRIDAY",
    SATURDAY = "SATURDAY",
    SUNDAY = "SUNDAY",
}

export type WeekDaysType = keyof typeof WeekDays

export type ProductGroupItem = Readonly<{
    id: number
    productGroupCode?: ProductGroupCode
    name: string
    isActive: boolean
}>

export type ProductGroupCode = {
    id: number
    number: string
    name: string
    description?: string
    isActive?: boolean
}

export type ProductGroup = Readonly<{
    id: number
    name: string
    isActive?: boolean
    productGroupCode?: ProductGroupCode
    availabilityDetails?: {
        weekDays: WeekDaysType[]
        timeInterval: {
            start: string
            end: string
        }
    }
    securitySettings?: {
        isLocked: boolean
    }
    history: History
}>

export type CreateProductGroup = Readonly<StrictOmit<ProductGroup, "id" | "productGroupCode" | "history"> & {
    productGroupCode?: {
        id: number | null
    }
}>

export type UpdateProductGroupState = {
    productGroupId: number | undefined
}

export type ProductGroupFormValues = Readonly<{
    name: string
    isActive?: boolean
    availableTime: boolean
    weekDays: WeekDaysType[]
    timeIntervalStart: DateTime
    timeIntervalEnd: DateTime
    productGroupCode?: ProductGroupCode
    isLocked: boolean
}>
